import { render, staticRenderFns } from "./WelfareCentreIntroduce.vue?vue&type=template&id=7e416059&scoped=true&"
import script from "./WelfareCentreIntroduce.vue?vue&type=script&lang=js&"
export * from "./WelfareCentreIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./WelfareCentreIntroduce.vue?vue&type=style&index=0&id=7e416059&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e416059",
  null
  
)

export default component.exports